import { useFormStore } from '../stores/form'

export default function ({ redirect, route }) {
  const store = useFormStore()

  if (route.name === 'lidmaatschap' && !store.steps.gym && !route.query.club) {
    redirect('/')
  }
  if (store.clubHasAddons && route.name === 'extra-opties' && !store.steps.membership) {
    redirect('/lidmaatschap')
  }
  if (route.name === 'persoonlijke-gegevens' && !store.steps.membership) {
    redirect('/lidmaatschap')
  }
  if (store.clubHasAddons && route.name === 'betalingsgegevens' && !store.steps.optionalExtras) {
    redirect('/extra-opties')
  }
  if (route.name === 'betalingsgegevens' && !store.steps.personalInformation) {
    redirect('/persoonlijke-gegevens')
  }
  if (route.name === 'betalingsgegevens' && store.steps.payment) {
    store.clearStore()
    redirect('/')
  }
  if (route.name === 'bedankt' && !store.steps.payment) {
    redirect('/betalingsgegevens')
  }
}
